import { ReactComponent as Rocket } from "./rocket.svg";
import DashboardHome from "./dash_home.png";
import Customers from "./customers.png";
import Suppliers from "./suppliers.png";
import Transactions from "./transactions.png";
import Blogs from "./blogs.svg";
import Policies from "./policies.svg";
import SupportMessages from "./support-messages.svg";
import NewsLetter from "./newsletter.svg";
import Settings from "./setting.svg";
import { ReactComponent as CustomerIcon } from "./customers-icon.svg";
import { ReactComponent as SuppliersIcon } from "./suppliers-icon.svg";
import { ReactComponent as TransactionsIcon } from "./transcations-icon.svg";
import { ReactComponent as Info } from "./info.svg";
import { ReactComponent as Block } from "./block.svg";
import { ReactComponent as UpdateBlog } from "./update-blog.svg";
import { ReactComponent as Logout } from "./log-out.svg";
import { ReactComponent as ChevLeft } from "./chev-left.svg";
import { ReactComponent as ChevRight } from "./chev-right.svg";
import { ReactComponent as Mail } from "./mail.svg";
import { ReactComponent as Lock } from "./lock.svg";
import { ReactComponent as Eye } from "./eye.svg";
import { ReactComponent as EyeDisable } from "./eye-disable.svg";
import { ReactComponent as Hamburger } from "./hamburger.svg";
import { ReactComponent as DropDown } from "./dropDown.svg";
import { ReactComponent as Phone } from "./phone.svg";
import { ReactComponent as Cross } from "./cross.svg";
import { ReactComponent as Trash } from "./trash.svg";
import { ReactComponent as Search } from "./search.svg";
import { ReactComponent as ChevUp } from "./chev-up.svg";
import { ReactComponent as ChevDown } from "./chev-down.svg";
import { ReactComponent as TrashOutline } from "./trash-outline.svg";
import { ReactComponent as User } from "./user.svg";
import { ReactComponent as ArrowLeft } from "./arrow-left.svg";
import { ReactComponent as ArrowRight } from "./arrow-right.svg";
import { ReactComponent as ArrowUp } from "./arrow-up.svg";
import { ReactComponent as ArrowDown } from "./arrow-down.svg";
import { ReactComponent as CameraPlus } from "./camera-plus.svg";
import { ReactComponent as Bell } from "./bell.svg";
import { ReactComponent as Plus } from "./plus.svg";
import { ReactComponent as Filter } from "./filter.svg";
import { ReactComponent as Pencil } from "./pencil.svg";
import { ReactComponent as TrashOutline2 } from "./trash-outline-2.svg";
import { ReactComponent as VerticalDots } from "./vertical-dots.svg";
import { ReactComponent as Tick } from "./tick.svg";
import { ReactComponent as ArrowRightOutline } from "./arrow-right-outline.svg";
import { ReactComponent as Download } from "./download.svg";
import { ReactComponent as Payment } from "./payment.svg";
import { ReactComponent as DashboardStats1 } from "./dashboard-stats-1.svg";
import { ReactComponent as DashboardStats2 } from "./dashboard-stats-2.svg";
import { ReactComponent as DashboardStats3 } from "./dashboard-stats-3.svg";
import { ReactComponent as Logo } from "./logo.svg";
import { ReactComponent as Accept } from "./accept.svg";
import { ReactComponent as Reject } from "./reject.svg";
import { ReactComponent as CheckFilledLight } from "./check-filled-light.svg";
import { ReactComponent as CrossFilledLight } from "./cross-filled-light.svg";

const Icons = {
  DashboardHome,
  Customers,
  CustomerIcon,
  SuppliersIcon,
  TransactionsIcon,
  Suppliers,
  Transactions,
  Blogs,
  Policies,
  SupportMessages,
  NewsLetter,
  Settings,
  Info,
  UpdateBlog,
  Rocket,
  Logout,
  ChevLeft,
  ChevRight,
  Mail,
  Lock,
  Eye,
  EyeDisable,
  Hamburger,
  DropDown,
  Phone,
  Cross,
  Trash,
  Search,
  ChevUp,
  ChevDown,
  TrashOutline,
  User,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowDown,
  CameraPlus,
  Bell,
  Plus,
  Filter,
  Pencil,
  TrashOutline2,
  VerticalDots,
  Tick,
  ArrowRightOutline,
  Download,
  Payment,
  DashboardStats1,
  DashboardStats2,
  DashboardStats3,
  Logo,
  Accept,
  Reject,
  CheckFilledLight,
  CrossFilledLight,
  Block,
};

export { Icons };
